'use client';

/* eslint-disable @typescript-eslint/no-unused-vars */

import React from 'react';
import * as Sentry from '@sentry/nextjs';

interface Props {
    children: React.ReactNode;
    fallback: React.ReactNode;
}

export class ErrorBoundary extends React.Component<Props, { hasError: boolean }> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        Sentry.captureException(error, {
            tags: { scope: 'Client' },
            extra: { info },
        });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }

        return this.props.children;
    }
}
